import Cookie from 'js-cookie';

const Token = 'token';
const expires = new Date(new Date() * 1 + 86400000 * 20);
const domain = process.env.VUE_APP_COOKIE_DOMAIN;
const path = "/";
const passport = process.env.VUE_APP_PASSPORT_URL;


export function getToken(){
    return Cookie.get(Token);
}

export function setToken(token, nickname, avatar, slug){
    try{
        Cookie.set(Token, token, {expires:expires, domain: domain, path: path});
        Cookie.set('nickname', nickname, {expires: expires, domain:domain, path: path});
        Cookie.set('avatar', avatar, {expires:expires, domain: domain, path: path});
        Cookie.set('slug', slug, {expires: expires, domain: domain, path: path});
        return true
    }
    catch (e) {
        console.log(e)
        return false
    }
}

export function removeToken(){
    try{
        Cookie.remove(Token, {path: path, domain: domain});
        Cookie.remove("avatar", {path: path, domain: domain});
        Cookie.remove('nav_cache', {domain:  domain, path: path});
        Cookie.remove("slug", {path: path, domain: domain});
        Cookie.remove("nickname", {path: path, domain: domain});
        window.location.href = passport + '/sign?red=' + window.location.href;
        return true
    }
    catch (e) {
        console.log(e)
        return false
    }
}